// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:12:22

export default {
  "id": "brain-challenge",
  "slug": "brain-challenge",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/4536069b05bb4bdc937e3ae18ba631e1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/4536069b05bb4bdc937e3ae18ba631e1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Brain Challenge",
      "description": "This game will challenge your mind, think out of the box\nUnexpected and mind-blowing answers will amaze you\n250 Fun levels.\n\nFeatures:\n- Solve fun & mind-challenging puzzles\n- Think out of the box\n- Simple & addictive gameplay\n\n** Credits:\n\"Ukulele\"\n\"Royalty Free Music from Bensound\"\n\n\"Forest\" & \"calm-bgm\"\nMusic by \"BandCamp - syncopika\"\n\nMenu vector created by jcomp - www.freepik.com\nMenu vector created by upklyak - www.freepik.com",
      "instructions": "Drag and Drop, Click",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "kidgames",
        "logic",
        "thinking",
        "trivia"
      ]
    },
    "zh-CN": {
      "title": "脑力挑战",
      "description": "这款游戏将挑战你的思维，跳出思维定势\n意想不到的震撼答案会让你感到惊奇\n250个趣味关卡。\n\n特色功能：\n- 解决有趣且挑战思维的谜题\n- 跳出思维定势\n- 简单且上瘾的游戏玩法\n\n**致谢：\n\"Ukulele\"\n\"来自Bensound的免费音乐\"\n\n\"森林\"与\"calm-bgm\"\n音乐由\"BandCamp - syncopika\"创作\n\n菜单矢量图由jcomp创作 - www.freepik.com\n菜单矢量图由upklyak创作 - www.freepik.com",
      "instructions": "拖放，点击",
      "genres": [
        "谜题",
        "问答"
      ],
      "tags": [
        "儿童游戏",
        "逻辑",
        "思考",
        "知识问答"
      ]
    },
    "zh-TW": {
      "title": "腦力挑戰",
      "description": "這款遊戲將挑戰您的思維，跳出思維框架\n意想不到且令人驚嘆的答案將令您驚艷\n250 個有趣關卡。\n\n特色：\n- 解決有趣且挑戰思維的謎題\n- 跳出思維框架\n- 簡單且上癮的遊戲玩法\n\n** 編劇：\n\"烏克麗麗\"\n來自 Bensound 的免版稅音樂\"\n\n\"森林\"與\"calm-bgm\"\n音樂由 \"BandCamp - syncopika\" 提供\n\n菜單向量圖由 jcomp 创作於 www.freepik.com\n菜單向量圖由 upklyak 创作於 www.freepik.com",
      "instructions": "拖放、點擊",
      "genres": [
        "謎題",
        "問答遊戲"
      ],
      "tags": [
        "兒童遊戲",
        "邏輯",
        "思考",
        "問答遊戲"
      ]
    },
    "zh-HK": {
      "title": "腦力挑戰",
      "description": "此遊戲將挑戰你的思維，跳出思維框架\n意想不到且令人驚嘆的答案將令你驚艷\n250個趣味關卡。\n\n特色：\n- 解決有趣且挑戰思維的謎題\n- 跳出思維框架\n- 簡單且上癮的遊戲玩法\n\n** 編輯人員名單：\n\"烏克麗麗\"\n來自 Bensound 的免版稅音樂\n\n\"森林\"及\"calm-bgm\"\n音樂由 \"BandCamp - syncopika\" 提供\n\n菜單向量圖由 jcomp - www.freepik.com 创作製作\n菜單向量圖由 upklyak - www.freepik.com 创作製作",
      "instructions": "拉拖及點擊",
      "genres": [
        "謎題",
        "智力問答"
      ],
      "tags": [
        "兒童遊戲",
        "邏輯",
        "思考",
        "知識小問答"
      ]
    },
    "ja": {
      "title": "脳力挑戦",
      "description": "このゲームはあなたの脳を挑戦し、箱外の考え方を促します。\n予想外で心を奪われる答えがあなたを驚かせます。\n250ステージの楽しいレベル。\n\n特徴:\n- 趣味深い、頭を使うパズルを解く\n- 箱外の考え方を試す\n- シンプルで魅力的なゲームプレイ\n\n** クレジット:\n\"Ukulele\"\n\"Bensoundからの無料音楽\"\n\n\"Forest\" & \"calm-bgm\"\n音楽: \"BandCamp - syncopika\"\n\nメニューのベクターデザイン: jcomp - www.freepik.com\nメニューのベクターデザイン: upklyak - www.freepik.com",
      "instructions": "ドラッグ＆ドロップ、クリック",
      "genres": [
        "パズル",
        "クイズ"
      ],
      "tags": [
        "子供のゲーム",
        "論理",
        "思考",
        "クイズ"
      ]
    },
    "ko": {
      "title": "뇌 도전",
      "description": "이 게임은 당신의 마음을 도전하며, 새로운 방식으로 생각하도록 할 것입니다.\n예상치 못한 놀라운 답변들이 당신을 놀라게 할 것입니다.\n250 개의 재미 있는 레벨.\n\n기능:\n- 재미 있고 지적 도전적인 퍼즐을 풀어보세요\n- 새로운 방식으로 생각하세요\n- 간단하고 중독성 있는 게임 플레이\n\n** 크레딧:\n\"Ukulele\"\n\"Bensound에서의 Royalty Free Music\"\n\n\"Forest\" & \"calm-bgm\"\n음악 제공: \"BandCamp - syncopika\"\n\n메뉴 벡터는 jcomp - www.freepik.com에서 생성\n메뉴 벡터는 upklyak - www.freepik.com에서 생성",
      "instructions": "드래그 앤 드롭, 클릭",
      "genres": [
        "퍼즐",
        "퀴즈"
      ],
      "tags": [
        "키드게임",
        "논리",
        "사고",
        "트리비어"
      ]
    },
    "fr": {
      "title": "Défi Cérébral",
      "description": "Ce jeu vous挑战你的大脑，跳出思维定势\n出乎意料且令人震撼的答案将令你惊叹\n250个趣味关卡。\n\nCaractéristiques :\n- Résolvez des puzzles amusants et stimulants\n- Pensez hors des sentiers battus\n- Gameplay simple et accrocheur\n\n** Crédits :\n\"Ukulele\"\nMusique gratuite de droit d'auteur de Bensound\"\n\n\"Forest\" & \"calm-bgm\"\nMusique par \"BandCamp - syncopika\"\n\nMenu vectorisé créé par jcomp - www.freepik.com\nMenu vectorisé créé par upklyak - www.freepik.com",
      "instructions": "Glisser et déposer, cliquer",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "jeux pour enfants",
        "logique",
        "pensée",
        "quiz"
      ]
    }
  }
};
